
import { Component, Vue } from 'vue-property-decorator';
import SearchBar from '~/components/SearchBar.vue';
import TheLayout from '~/components/TheLayout/index.vue';
import { uppercaseFirstCharacter } from '~/helpers';
import { ConfigModule } from '~/store/modules/config';

@Component({
    components: {
        TheLayout,
        SearchBar,
    },
})
export default class App extends Vue {
    created() {
        document.title = `ADMIN ${uppercaseFirstCharacter(ConfigModule.environmentPrefix)}: Support`;
    }
}
